import Vue from 'vue';
import VueI18nManager, {events} from 'vue-i18n-manager';
import store from '@/store';
import router from '@/router/index';

const proxy = {
	getTranslation: async () => {
		return await store.dispatch(`setting/GET_TRANSLATIONS`);
	}
};

Vue.use(VueI18nManager, {
	store,
	router,
	proxy,
	config: {
		defaultCode : getDefaultLang(),
		languages   : [
			{
				name: 'English',
				title: 'Eng.',
				key: 'en',
				code: 'en',
				urlPrefix: 'en',
				translationKey: 'en',
				flagKey: 'en',
			},
			{
				name: 'Ukrainian',
				title: 'Ukr.',
				key: 'uk',
				code: 'uk',
				urlPrefix: 'uk',
				translationKey: 'uk',
				flagKey: 'uk',
			},
			//{
			//	name: 'Indonesian',
			//	title: 'Idn.',
			//	key: 'id',
			//	code: 'id',
			//	urlPrefix: 'id',
			//	translationKey: 'id',
			//	flagKey: 'id',
			//},
		],
		translations: proxy,
	},
});

function getDefaultLang()
{
	if(location.pathname.substr(1, 3) == 'ru/') {
		return 'uk';
	} else if (location.pathname.substr(1, 3) == 'id/') {
		//return 'id';
		return 'en';
	} else if (location.pathname.substr(1, 3) == 'uk/') {
		return 'uk';
	} else {
		return 'en';
	}
}

export class translationUtils {
	static setInterfaceLanguage(locale) {
		console.log('Set interface language = ' + locale)
		
		store.dispatch(events.SET_LANGUAGE, locale)
			.then(() => console.log('interface language changed'));
	}
}
